import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: "",
    token: localStorage.getItem("token") || "",
    user: null,
    contratoId: "",
    contactoId: "",
    username: "",
    tipeView: "",
    tabSelected: "",
    subTabSelected: "",
    evolucionTabSelected: "",
    aplicacionTabSelected: "",
    rolInContract: "",
    visitaId: "",
    subProTabSelected: "",
    idDocumentoValidacion: "",
    idDocumentoValidacionHistorico: "",
    viewValidaciones: "",
    proSelected: "",
    filenameValue: "",
    base64Value: "",
    nombreProveedor: "",
    contrato_cod: "",
    contrato_periodo: "",
    perfil: null,
    contrato_cerrado: false,
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, response) {
      state.status = "success";
      state.token = response.token;
      state.user = response;

      // console.log("user::" + JSON.stringify(state.user, null, 2) + "::");

      //si perfil no es nulo y codigo no es nulo
      if (state.user.perfil != null && state.user.perfil.codigo != null) {
        state.perfil = state.user.perfil.codigo;
      }
    },
    auth_error(state) {
      // console.log("auth_error::state::" + JSON.stringify(state, null, 2) + "::");
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.user = "";
      state.contratoId = "";
      state.username = "";
      state.tipeView = "";
      state.tabSelected = "";
      state.subTabSelected = "";
      state.evolucionTabSelected = "";
      state.aplicacionTabSelected = "";
      state.rolInContract = "";
      state.visitaId = "";
      state.subProTabSelected = "";
      state.idDocumentoValidacion = "";
      state.idDocumentoValidacionHistorico = "";
      state.viewValidaciones = "";
      state.proSelected = "";
      state.perfil = "";
    },
    tab_state(state, tabSelected) {
      state.tabSelected = tabSelected;
    },
    sub_tab_state(state, subTabSelected) {
      state.subTabSelected = subTabSelected;
    },
    sub_pro_tab_state(state, subProTabSelected) {
      state.subProTabSelected = subProTabSelected;
    },
    pro_state(state, proSelected) {
      state.proSelected = proSelected;
    },
    evolucion_tab_state(state, evolucionTabSelected) {
      state.evolucionTabSelected = evolucionTabSelected;
    },
    aplicacion_tab_state(state, aplicacionTabSelected) {
      state.aplicacionTabSelected = aplicacionTabSelected;
    },
    view_state(state, tipeView) {
      state.tipeView = tipeView;
    },
    contrato_state(state, contratoId) {
      state.contratoId = contratoId;
    },
    document_state(state, filenameValue, base64Value) {
      state.filenameValue = filenameValue;
      state.base64Value = base64Value;
    },
    contacto_state(state, contactoId) {
      state.contactoId = contactoId;
    },
    username_state(state, username) {
      state.username = username;
    },
    visita_state(state, visitaId) {
      state.visitaId = visitaId;
    },
    rolInContract_state(state, role) {
      state.rolInContract = role;
    },
    validaciones_state(state, idDocumento) {
      state.idDocumentoValidacion = idDocumento;
    },
    validacionesHistorico_state(state, idDocumentoHistorico) {
      state.idDocumentoValidacionHistorico = idDocumentoHistorico;
    },
    view_validaciones_state(state, view) {
      state.viewValidaciones = view;
    },
    proveedor_state(state, nombreProveedor) {
      state.nombreProveedor = nombreProveedor;
    },
    contrato_cod(state, codigoContrato) {
      state.contrato_cod = codigoContrato;
    },
    contrato_periodo(state, periodoContrato) {
      state.contrato_periodo = periodoContrato;
    },
    perfil(state, perfil) {
      state.perfil = perfil;
    },
    contrato_cerrado(state, contratoCerrado) {
      state.contrato_cerrado = contratoCerrado;
    },
  },
  actions: {
    async login({ commit }, user) {
      //antiguo login por BD
      return await new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: "/authenticate",
          data: user,
          method: "POST",
        })
          .then((resp) => {
            let token = resp.data.token;
            let response = resp.data;
            localStorage.setItem("token", token);
            localStorage.setItem("userId", response.user.id);
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
            commit("auth_success", response);
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            localStorage.removeItem("token");
            localStorage.removeItem("userId");
            reject(err);
          });
      });
    },
    async loginExterno({ commit }, user) {
      console.log("loginGoogle22::" + user + "::");
      return await new Promise((resolve, reject) => {
        commit("auth_request");
        let token = user.response.data.token;
        let response = user.response.data;
        localStorage.setItem("token", token);
        localStorage.setItem("userId", user.response.data.id);
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        commit("auth_success", response);
        resolve(user.response);
      });
    },

    logout({ commit }) {
      return new Promise((resolve, reject) => {
        commit("logout");
        //llamaral back cerrar sesion
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        localStorage.removeItem("userLogged");
        delete axios.defaults.headers.common["Authorization"];
        resolve();
      });
    },
  },
  getters: {
    token: (state) => state.token,
    isLoggedIn: (state) => !!state.token,
    userLogged: (state) => state.user,
    authStatus: (state) => state.status,
    contratoStored: (state) => state.contratoId,
    usernameStored: (state) => state.username,
    contactoStored: (state) => state.contactoId,
    tipeViewStored: (state) => state.tipeView,
    tabSelectedStored: (state) => state.tabSelected, //tabs Proveedor, proceso, panel de control
    subTabSelectedStored: (state) => state.subTabSelected, //pestanna en rombo
    subProTabSelectedStored: (state) => state.subProTabSelected, //rombo
    evolucionTabSelectedStored: (state) => state.evolucionTabSelected,
    aplicacionTabSelectedStored: (state) => state.aplicacionTabSelected,
    rolIncontractStored: (state) => state.rolInContract,
    visitaStored: (state) => state.visitaId,
    idDocumentoValidacion: (state) => state.idDocumentoValidacion,
    idDocumentoValidacionHistorico: (state) =>
      state.idDocumentoValidacionHistorico,
    viewValidaciones: (state) => state.viewValidaciones,
    proSelectedStored: (state) => state.proSelected,
    filenameStored: (state) => state.filenameValue,
    base64Stored: (state) => state.base64Value,
    nombreProveedorStored: (state) => state.nombreProveedor,
    contratoCodStored: (state) => state.contrato_cod,
    contratoPerStored: (state) => state.contrato_periodo,
    perfilStored: (state) => state.perfil.codigo,
    contratoCerradoStored: (state) => state.contrato_cerrado,
  },
});
